import React from 'react'
import { arrayStatus as arrayStatus_water_truck_request } from '../../const/constStatuses_waterTruckRequest'

const ProgressBarStatus = ({ category, status, staticProcess = false }) => {
  const getProcessAndStyle = () => {
    if (status) {
      return {
        progress: staticProcess ? 100 : status.progress,
        color: status.color,
        labelMain: status.name,
      }
    }

    return {
      progress: 0,
      color: '#ADD8E6',
      labelMain: '---',
    }
  }

  const { progress, color, labelMain } = getProcessAndStyle()

  return (
    <div className={`progress-bar-container`}>
      <div
        className={`progress-bar`}
        style={{
          width: `${progress}%`,
          backgroundColor: color,
        }}
      ></div>{' '}
      <div className="progress-bar-text-container ">
        <span className="progress-bar-text">{labelMain}</span>
      </div>
    </div>
  )
}

export default ProgressBarStatus
